const InitializeFader = (): void => {
    const fadeInPage = (): void => {
        if (!window.AnimationEvent) {
            return;
        }

        const fader = document.getElementById('fader')!;
        fader.setAttribute('class', 'fade-out');
    };

    fadeInPage();

    window.onload = (): void => {
        if (!window.AnimationEvent) {
            return;
        }

        const anchors = Array.from(document.getElementsByTagName('a'));

        for (const anchor of anchors) {
            const isSameHostname = anchor.hostname === window.location.hostname;
            const isSamePage = anchor.pathname === window.location.pathname;
            const isOpenInNewTab = anchor.target === '_blank' || anchor.target === '_top';

            if (isSameHostname && !isSamePage && !isOpenInNewTab) {
                anchor.addEventListener('click', event => {
                    if (event.metaKey || event.ctrlKey) {
                        return;
                    }
                    const fader = document.getElementById('fader');
                    if (!fader) {
                        return;
                    }
                    const anchorElement = event.currentTarget as HTMLAnchorElement;
                    if (!anchorElement) {
                        return;
                    }

                    const listener = function(): void {
                        window.location.href = anchorElement.href;
                        fader.removeEventListener('animationend', listener);
                    };
                    fader.addEventListener('animationend', listener);

                    event.preventDefault();
                    fader.classList.add('fade-in');
                });
            }
        }
    };

    window.addEventListener('pageshow', event => {
        if (!event.persisted) {
            return;
        }
        const fader = document.getElementById('fader');
        fader!.classList.remove('fade-in');
        fader!.setAttribute('class', 'fade-out');
    });

    // Handle the back button (or any history navigation)
    window.addEventListener('popstate', () => {
        const fader = document.getElementById('fader');
        if (fader) {
            // Trigger the fade-out animation first
            fader.classList.remove('fade-in');
            fader.setAttribute('class', 'fade-out');

            // Wait for fade-out animation to end, then fade-in
            const listener = (): void => {
                fader.classList.add('fade-in');
                fader.removeEventListener('animationend', listener);
            };
            fader.addEventListener('animationend', listener);
        }
    });
};

export default InitializeFader;
